<template>
  <v-container fluid grid-list-md class="pa-0">
    <v-card class="w-100 no-shadow px-3 py-2 card-r">
      <v-layout wrap align-center>
        <v-flex lg1 sm1 xs2 class="text-xs-center">
          <v-btn icon class="tow-clor-1 text-white card-r" @click="$refs.calendar.prev()">
            <v-icon dark>keyboard_arrow_left</v-icon>
          </v-btn>
        </v-flex>
        <v-flex lg2 xs8 sm2 class="text-xs-center filter-class pt-2">
          <v-select solo
                    class="pa-0 ma-0"
                    solo
                    v-model="type"
                    :items="typeOptions"
                    label="Type"
          ></v-select>
        </v-flex>
        <v-flex lg1 sm1 xs2 class="text-xs-center">
          <v-btn icon class="tow-clor-1 text-white card-r" @click="$refs.calendar.next()">
            <v-icon dark>keyboard_arrow_right</v-icon>
          </v-btn>
        </v-flex>
        <v-flex lg2 sm2 xs12 class="text-xs-center ewrsrvferfe">
          <v-btn class="tow-clor-1 text-white card-r" @click="classdialog = true">
            <v-icon class="text-white f-20 pr-2">note_add</v-icon>class
          </v-btn>
        </v-flex>
        <v-flex lg2 sm2 xs12 class="text-xs-center ewrsrvferfe">
          <!--<v-dialog v-model="eventdialog" persistent max-width="700">-->
          <!--<v-btn color="primary" slot="activator">-->
          <v-btn class="tow-clor-1 text-white card-r" :to="'/CreateEvent/'+teacherId">
            <v-icon class="text-white f-20 pr-2">note_  </v-icon>event
          </v-btn>
          <!--<v-card class="white no-shadow">-->
          <!--<div class="right">-->
          <!--<v-btn flat @click="eventdialog = false" icon color="primary" class="mt-0 pt-0">-->
          <!--<v-icon>close</v-icon>-->
          <!--</v-btn>-->
          <!--</div>-->
          <!--<div>-->
          <!--<create-event/>-->
          <!--</div>-->
          <!--</v-card>-->
          <!--</v-dialog>-->
        </v-flex>
        <v-flex v-show="!seen" lg4 sm4 xs12 class="text-lg-right text-xs-center">
          <v-btn class="tow-clor-1 text-white card-r text-lg-right text-xs-center" v-show="!seen" v-on:click='seen = !seen'>
            <v-icon class="text-white f-20 pr-2">filter_list</v-icon>Filter by date</v-btn>
        </v-flex>
        <v-flex v-show="seen" lg4 sm4 xs12 class="text-xs-center closed">
          <v-btn icon small class="tow-clor-1 text-white card-r right" v-show="seen" v-on:click='seen = !seen'>
            <v-icon dark class="text-white f-15">close</v-icon>
          </v-btn>
          <div class="mt-1 right">
            <date-dropdown v-show="seen" v-on:click='seen = !seen' default="1995-01-10" v-model="selectedDate" />
          </div>
        </v-flex>
        <v-sheet height="500" class="w-100 mt-2" slot="activator">
          <v-calendar class="w-100"
                      ref="calendar"
                      v-model="start"
                      :type="type"
                      color="primary"
                      @click:date="loadData($event)"
          ></v-calendar>
        </v-sheet>
        <v-flex xs12 class="">
          <v-dialog v-model="calenderdialog" persistent max-width="800" class="w-100">
            <v-list tow-line class="card-r">
              <div class="right">
                <v-btn flat @click="calenderdialog = false" icon color="primary" class="mt-0 pt-0">
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
              <template>
                <v-subheader>
                  {{selectedDate}}
                </v-subheader>

                <v-divider></v-divider>
                <v-flex class="text-xs-center" v-if="loading">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </v-flex>
                <v-alert
                  :value="true"
                  v-if="alertType"
                  :type="alertType"
                >
                  {{msg}}
                </v-alert>
                <v-list-tile v-for="(item, index) in items" v-if="!loading">
                  <v-layout align-center wrap row>
                    <v-flex lg1 sm1 xs2>
                      <v-list-tile-avatar >
                        <img class="border-primary" :src="item.avatar">
                      </v-list-tile-avatar>
                    </v-flex>
                    <v-flex lg9 sm9 xs5 class="text-xs-left">
                      <v-list-tile-content>
                        <v-list-tile-title>{{item.title}}</v-list-tile-title>
                        <v-list-tile-sub-title><span class='text--primary'>{{item.subtitle}}</span></v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-flex>
                    <v-flex lg1 sm1 xs3 class="text-xs-right" v-if="item.bookType=='teacher_events'">
                      <v-btn  @click="confirmDeletePopup(item)" flat icon color="primary" class="mt-0" v-if="item.bookType=='teacher_events'">
                        <!-- <v-icon>event</v-icon> -->
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex lg1 sm1 xs2 class="text-xs-right" v-if="item.bookType=='teacher_events'">
                      <!-- <v-btn to="/CreateEvent" flat icon color="primary" class="mt-0" v-if="item.bookType=='teacher_events'">
                        <v-icon>event</v-icon>
                      </v-btn> -->
                      <!-- <v-btn @click="editEventPopup(item.id)" flat icon color="primary" class="mt-0" v-if="item.bookType=='teacher_events'"> -->
                      <v-btn :to="'/EditEvent/'+item.id+'/'+teacherId" flat icon color="primary" class="mt-0" v-if="item.bookType=='teacher_events'">
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex lg1 sm1 xs2 class="text-xs-right" v-if="item.bookType=='student_booking'">
                      <v-btn flat slot="activator" @click="setModulePopupData(item)" icon color="primary">
                        <v-icon>visibility</v-icon>
                      </v-btn>
                    </v-flex>

                    <v-flex lg1 sm1 xs3 class="text-xs-right" v-if="item.bookType=='teacher_bookings'">
                      <router-link :to="'/FreeSlots/'+item.id+'/'+teacherId" v-if="item.status==true">
                        <v-btn flat icon color="primary">
                          <v-icon class="f-20 textColor">fas fa-plus</v-icon>
                        </v-btn>
                      </router-link>
                    </v-flex>
                    <v-flex lg1 sm1 xs2 class="text-xs-right" v-if="item.bookType=='teacher_bookings'">

                      <v-switch
                        v-model="item.status"
                        class="right pt-0 ma-0"
                        color="primary"
                        hide-details
                        @change="changeStatus(item.status,item.id)"
                      ></v-switch>
                    </v-flex>

                  </v-layout>
                </v-list-tile>

              </template>
            </v-list>
          </v-dialog>

        </v-flex>
        <v-dialog v-model="classdialog" persistent max-width="500" class="">

          <v-card class="white no-shadow pa-3 card-r">
            <v-toolbar class="tow-clor-1 card-r mb-2 shadow-1 pl-3 text-white">
              <div class="text-xs-left f-17 text-capitalize">Add Students in Class</div>
              <v-spacer></v-spacer>
              <v-btn @click="classdialog = false" icon color="white" class="mr-2 card-r">
                <v-icon class="text-primary">close</v-icon>
              </v-btn>
            </v-toolbar>
            <div>
              <free-slots/>
            </div>
          </v-card>
        </v-dialog>

        <v-dialog v-model="addclass" persistent max-width="290">

          <v-flex xs12 class="pt-0"
                  v-for="card in cards"
                  :key="card.title"
                  v-bind="{ [`xs${card.flex}`]: true }"
          >
            <v-btn
              dark
              icon
              fab
              @click="ddad = false"
              small
              class="card-r no-shadow ma-0 text-white text-xs-right"
              color="primary"
            >
              <v-icon color="white">fas fa-arrow-left</v-icon>

            </v-btn>
            <v-card class="no-shadow mt-3 transparent">
              <!--<a href="#/viewclass">-->
              <!--<v-list subheader>-->
              <!--<v-list-tile-->
              <!--to="/teacherchat"-->
              <!--v-for="item in items"-->
              <!--:key="item.title"-->
              <!--avatar-->
              <!--@click=""-->
              <!--class="pl-0"-->
              <!--&gt;-->
              <!--<v-list-tile-avatar>-->
              <!--<img class="objec-fit" to="studentprofile"  :src="item.avatar">-->
              <!--</v-list-tile-avatar>-->

              <!--<v-list-tile-content>-->
              <!--<v-list-tile-title v-html="item.title"></v-list-tile-title>-->
              <!--</v-list-tile-content>-->

              <!--<v-list-tile-action>-->
              <!--<v-icon color="primary">chat_bubble</v-icon>-->
              <!--</v-list-tile-action>-->
              <!--</v-list-tile>-->
              <!--</v-list>-->
              <v-btn class="no-height ma-0 pb-0 card-r no-shadow">

                <v-img :src="card.src" height="350px" class="top-r">
                  <v-container fill-height fluid pa-2 >
                    <v-layout class="ma-5 card-r card-shade" fill-height>
                      <v-flex xs12 align-end flexbox class="">
                        <span class="f-20 white--text t-shadow" v-text="card.title"></span>
                        <div class="f-30 white--text t-shadow"
                        >{{dob}}</div>
                        <!--v-text="card.date"-->
                        <a :href="`#/ViewStudentTab`" class="">

                          <v-avatar
                            :size="125"
                            color="grey lighten-4">
                            <img class="br-3 objec-fit"
                                 src="https://greatertulsadrivingschool.files.wordpress.com/2012/09/image_oregon-driver-education-center-2_grid_6.jpg" alt="avatar">
                          </v-avatar>
                        </a>
                        <div class="f-30 white--text t-shadow" v-text="card.time"></div>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-img>
              </v-btn>
              <!--</a>-->

              <v-card-actions class="pa-0">
                <!-- <v-dialog  class="pa-0 border-r display-unset w-50" v-model="ChangeTime" width="700">
                  <v-btn   slot="activator"
                            class= "w-100 left-r btnM no-shadow text-white"
                            color="primary">Change Time</v-btn>
                  <v-card class="card-r no-shadow">
                    <v-layout row xs12 justify-center>
                      <v-flex xs12>
                        <v-layout wrap>
                          <v-flex xs12 class=" ma-2">
                            <div class="text-sm-left pl-2 f-20" color="#002d4a"  >Change Time</div>
                          </v-flex>
                          <v-divider></v-divider>
                        </v-layout>
                        <v-container fluid grid-list-xl>
                          <v-layout row wrap class="">
                            <v-flex d-flex lg4 sm4 xs12 class="textFeald date">
                              <v-menu
                                ref="menu1"
                                v-model="birthday"
                                :close-on-content-click="false"
                                lazy
                                full-width
                                persistent
                                max-width="290px"
                                min-width="290px"
                              >
                                <v-text-field
                                  slot="activator"
                                  v-model="dob"
                                  label="Select Date"
                                  persistent-hint
                                  value="John Doe"
                                  solo
                                  placeholder="dd/mm/yyyy"
                                ></v-text-field>
                                <v-date-picker v-model="dob" no-title scrollable>
                                  <v-spacer></v-spacer>
                                  <v-btn flat color="primary" @click="ddad = false">Cancel</v-btn>
                                  <v-btn flat color="primary" @click="setdate(dob)">OK</v-btn>
                                </v-date-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex d-flex lg4 sm4 xs12 class="textFeald  w-100">
                              <v-select
                                v-model="timeselect"
                                :items="timeslot"
                                class="input-group--focused"
                                placeholder="select your time"
                                solo
                              ></v-select>
                            </v-flex>
                            <v-flex d-flex lg4 sm4 xs12>
                              <v-btn @click="ddad = false" larg depressed class="no-shadow card-r ml-4 mr-4" color="primary">Change time</v-btn>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-dialog> -->
                <!-- <v-dialog  class="pa-0 display-unset w-50" v-model="dialog" width="700">
                  <v-btn   slot="activator"
                            class= "w-100 right-r btnM no-shadow text-white"
                            color="primary">Cancel booking</v-btn>
                  <v-card class="card-r no-shadow">
                    <v-layout row xs12 justify-center>
                      <v-flex xs12>
                        <v-layout wrap>
                          <v-flex xs12 class=" ma-2">
                            <div class="text-sm-left pl-2 f-20" color="#002d4a"  >Confirm Cancelation</div>
                          </v-flex>
                          <v-divider></v-divider>
                        </v-layout>
                        <v-container fluid grid-list-xl>
                          <v-layout row wrap class="">
                            <v-flex d-flex lg4 sm4 xs12 class="textFeald date">
                              <p>
                                Cantor’s Driving School offers driver training packages – bundles of our most popular services that help you save money whi
                                le purchasing top quality defensive driver training.
                                Cantor’s Driving School gives private, one-on-one, on-the-road driving lessons 7 days a week, day and evening
                                hours. Door-to-door service is provided – we pick you up and we drop you off at your school, work, house or apartment.
                              </p>
                            </v-flex>
                            <v-flex d-flex lg4 sm4 xs12>
                              <v-btn @click="ddad = false" larg depressed class="no-shadow card-r w-100" color="primary">cancel</v-btn>
                              <v-btn @click="ddad = false" larg depressed class="no-shadow card-r w-100" color="primary">Confirm</v-btn>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-dialog> -->

                <!--<v-btn icon>-->
                <!--<v-icon>bookmark</v-icon>-->
                <!--</v-btn>-->
                <!--<v-btn icon>-->
                <!--<v-icon>share</v-icon>-->
                <!--</v-btn>-->
              </v-card-actions>

            </v-card>
          </v-flex>
        </v-dialog>
        <v-dialog class="pa-0 border-r display-unset w-50" v-model="confirmDelete" width="700">
          <v-card class="card-pop card-r no-shadow pa-3">
            <div  class="pt-3 mt-5 text-xs-center">
                <span class="f-20">
                    Are You Sure?
                </span>
            </div>
            <v-layout>
              <v-flex>
                <v-flex xs12 class="pt-2">
                  <v-list>

                    <v-card color="grey lighten-2" class="mt-2 mb-4 pt-3 pa-2 mb-2 card-r no-shadow">
                      <v-list-tile>
                        <v-list-tile-action>
                          <v-icon color="primary" class="f-30">info</v-icon>
                        </v-list-tile-action>

                        <v-list-tile-content>
                          <v-list-tile-title v-html="'Event name : '+confirmDeleteData.title"></v-list-tile-title>
                        </v-list-tile-content>

                      </v-list-tile>

                    </v-card>
                  </v-list>
                </v-flex>
                <v-flex xs12 class="text-xs-center mr-1">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    v-if="deleteEventLoading"
                  ></v-progress-circular>
                  <v-alert
                    :value="true"
                    v-if="eventAlert"
                    :type="eventAlert"
                  >
                    {{eventMsg}}
                  </v-alert>
                </v-flex>
                <v-layout xs12>
                  <v-flex xs12 class="text-xs-left mr-1">
                    <v-btn @click="confirmDelete = false" color="grey lighten-2" class="btn-customer card-r">Cancel</v-btn>
                  </v-flex>

                  <v-flex xs12 class="text-xs-right ml-1">
                    <v-btn @click="deleteEvent(confirmDeleteData.id)" class="btn-customer card-r primary text-white no-shadow card-r">Delete</v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card>

        </v-dialog>
        <v-dialog v-model="eventEditPopup" width="700" class="redius-t-20">
          <div id="calendar" class="">
            <!-- <v-toolbar flat fixed class="toolbar cont text-xs-center" app dark xs12>
              <div xs6 class="btn-tool text-xs-right">
                <router-link to="/teacher" class="no-deraction">
                <v-icon class="textColor pt-2">fas fa-arrow-left</v-icon>
                </router-link>
              </div>
              <v-spacer></v-spacer>
              <v-toolbar-title>
                <h2 class="textColor pl-3 text-xs-center font-weight-bold text-capitalize f-20">Update Event</h2>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items class="hidden-sm-and-down"></v-toolbar-items>

            </v-toolbar> -->
            <!-- <div></div> -->
            <v-card class="card-r no-shadow pb-3 pr-3 pl-3 pt-5 mt-3">
              <v-layout row wrap class="">
                <div class="f-15 text-xs-left w-100 grey--text font-weight-bold">Select Date</div>
                <v-flex d-flex lg12 sm3 xs12 class="">
                  <HotelDatePicker
                    v-if="event.start_date"
                    :displayClearButton=true
                    format="YYYY-MM-DD"
                    :i18n="ptBr"
                    :startingDateValue="new Date(event.start_date)"
                    :endingDateValue="new Date(event.end_date)"
                    :value="checkInValue"
                    :hovering-tooltip="false"
                    @check-in-changed="checkInChanged($event)"
                    @check-out-changed="checkOutChanged($event)">
                  </HotelDatePicker>
                </v-flex>
                <v-divider></v-divider>
              </v-layout>
              <v-flex d-flex lg4 sm3 xs12 class="mt-3">
                <v-text-field
                  prepend-icon="alarm"
                  v-model="event.selectedPlan"
                  solo
                  :disabled="loading"
                  label="whats is your plan"
                  placeholder="select your plan"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex class="text-xs-center pt-9" xs12 sm12 lg9 style="margin:auto">
                <pulse-loader :loading="loading" :color="'#004d98'"></pulse-loader>
              </v-flex>
              <v-flex v-if="alertType">
                <v-alert
                  :value="true"
                  color="success"
                  icon="check_circle"
                  outline
                  v-if="alertType=='success'"
                >
                  {{msg}}
                </v-alert>
                <v-alert
                  :value="true"
                  color="error"
                  icon="warning"
                  outline
                  v-if="alertType=='warning'"
                >
                  {{msg}}
                </v-alert>
              </v-flex>
              <v-flex d-flex xs12 class="text-xs-right">
                <v-btn :disabled="loading" class="w-25 text-white no-shadow card-r text-xs-right" @click="UpdateEvent" color="primary">Update</v-btn>
              </v-flex>


            </v-card>

          </div>
        </v-dialog>
        <v-dialog v-model="viewModulePopup" width="700" class="redius-t-20">
          <v-flex xs12 class="pt-0 card-contant">
            <v-card class="no-shadow card-r">

              <v-img :src="viewModulePopupData.image" class="top-r">
                <v-btn icon @click="viewModulePopup = false" class="card-r no-shadow text-white text-xs-right" color="primary">
                  <v-icon color="white" class="f-30">close</v-icon>
                </v-btn>
                <v-container fill-height fluid class="w-100 text-xs-center">
                  <v-layout class="ma-5 card-r">

                    <v-flex xs12 align-end flexbox class="">
                      <span class="f-20 white--text t-shadow" v-text="viewModulePopupData.name"></span>
                      <div class="f-30 white--text t-shadow"
                      >{{viewModulePopupData.date}}</div>
                      <v-avatar
                        :size="125"
                        color="grey lighten-4">
                        <img class="br-3 objec-fit"
                             :src="viewModulePopupData.image" alt="avatar">
                      </v-avatar>
                      <div class="f-30 white--text t-shadow" v-text="viewModulePopupData.time"></div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-img>

              <v-card-actions class="pa-0">
                <v-dialog class="pa-0 display-unset border-r w-50" v-model="ChangeTime" width="600">
                  <v-btn slot="activator"
                         @click="setClassDetails(viewModulePopupData.module_id,viewModulePopupData.package_id,viewModulePopupData.name,viewModulePopupData.student_id)"
                         class= "w-100 left-r h-50p no-shadow text-white"
                         color="primary">Change Time</v-btn>
                  <v-card class="card-r no-shadow">
                    <v-layout row xs12 justify-center>
                      <v-flex xs12>
                        <v-layout wrap>
                          <v-flex xs12 class=" ma-2">
                            <div class="text-sm-left pl-2 f-20" color="#002d4a">Change Time {{selectedDate}}</div>
                          </v-flex>
                          <v-divider></v-divider>
                        </v-layout>
                        <v-container fluid grid-list-xl>
                          <v-layout row wrap class="">
                            <v-flex d-flex lg12 xs12 class="textFeald date">
                              <v-menu
                                ref="menu1"
                                v-model="birthday"
                                :close-on-content-click="false"
                                lazy
                                full-width
                                persistent
                                max-width="290px"
                                min-width="290px"
                              >
                                <v-text-field
                                  slot="activator"
                                  v-model="dob"
                                  label="Select Date"
                                  persistent-hint
                                  value="John Doe"
                                  solo
                                  placeholder="dd/mm/yyyy"
                                ></v-text-field>
                                <v-date-picker v-model="dob" no-title scrollable :events="arrayEvents" event-color="green" @input="GetTime(dob)">
                                  <v-spacer></v-spacer>
                                  <v-btn flat color="primary" @click="birthday = false">Cansscel</v-btn>
                                  <v-btn flat color="primary" @click="setdate(dob)">OK</v-btn>
                                </v-date-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex d-flex lg12 xs12 class="textFeald  w-100">
                              <v-select
                                v-model="selectedTime"
                                :items="timeslot"
                                item-text="time_from"
                                item-value="id"
                                class="input-group--focused"
                                placeholder="select your time"
                                solo
                              ></v-select>
                            </v-flex>
                            <v-flex class="text-xs-center pt-9" d-flex lg12   xs12>
                              <pulse-loader :loading="loading1" :color="'#004d98'"></pulse-loader>
                            </v-flex>
                            <v-flex class="text-xs-center pt-9 pa-0" d-flex lg12   xs12>
                              <v-btn @click="ChangeTime = false" larg depressed class="h-50p no-shadow card-r w-100" color="primary">cancel</v-btn>
                              <v-btn @click="ChangeBookTime(viewModulePopupData.id,viewModulePopupData.module_id,viewModulePopupData.package_id,viewModulePopupData.attendance,viewModulePopupData.student_id)" v-if="!loading1" larg depressed class="h-50p no-shadow card-r w-100" color="primary">Change time</v-btn>
                            </v-flex>
                            <v-flex>
                              <v-alert
                                v-if="alertType=='success'"
                                :value="true"
                                color="success"
                                icon="check_circle"
                                outline
                              >
                                {{msg}}
                              </v-alert>
                              <v-alert
                                v-if="alertType=='warning'"
                                :value="true"
                                color="error"
                                icon="warning"
                                outline
                              >
                                {{msg}}
                              </v-alert>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-dialog>
                <v-dialog class="pa-0 display-unset w-50" v-model="dialog" width="600">
                  <v-btn  slot="activator"
                          class= "w-100 right-r h-50p no-shadow text-white"
                          color="primary">Cancel booking</v-btn>
                  <v-card class="card-r no-shadow">
                    <v-layout row xs12 justify-center>
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs12 class=" ma-2">
                            <div class="text-sm-left pl-2 f-20" color="#002d4a"  >Confirm Cancelation</div>
                          </v-flex>
                          <v-divider></v-divider>
                        </v-layout>
                        <v-container fluid grid-list-xl>
                          <v-layout row wrap class="">
                            <v-flex d-flex lg12   xs12 class="textFeald date">
                              <p>
                                Cantor’s Driving School offers driver training packages – bundles of our most popular services that help you save money whi
                                le purchasing top quality defensive driver training.
                                Cantor’s Driving School gives private, one-on-one, on-the-road driving lessons 7 days a week, day and evening
                                hours. Door-to-door service is provided – we pick you up and we drop you off at your school, work, house or apartment.
                              </p>
                            </v-flex>
                            <v-flex d-flex lg12 xs12 class="pa-0">
                              <v-btn @click="dialog = false" larg depressed class="h-50p no-shadow card-r w-100" color="primary">cancel</v-btn>
                              <v-btn  @click="cancelBooking(viewModulePopupData.id)" larg depressed class="h-50p no-shadow card-r w-100" color="primary">Confirm</v-btn>
                            </v-flex>
                            <v-flex d-flex lg12 xs12 class="pa-0" v-if="eventCancelAlert">
                              <v-alert value="true" :type="eventCancelAlert">{{eventCancelMsg}}</v-alert>
                            </v-flex>
                            <v-flex class="text-xs-center pt-9" xs12 sm12 lg9 style="margin:auto">
                              <pulse-loader :loading="loading" :color="'#004d98'"></pulse-loader>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-dialog>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-dialog>
    </v-layout>
    </v-card>
  </v-container>
</template>
<script>
  /* eslint-disable */
  import api from '@/utils/backend-api'
  import FreeSlots from './FreeSlots'
  import CreateEvent from './CreateEvent'
  import DateDropdown from 'vue-date-dropdown'
  import CreateClass from "../classes/CreateClass";
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
  export default {
    props:['id'],
    data: () => ({
      type: 'month',
      bookbutton:false,
      ex11 :[],
      ex10 :[],
      ex19 :[],
      calenderdialog: false,
      classdialog: false,
      eventdialog: false,
      seen:false,
      addclass:false,
      start: '2019-06-01',
      end: '2019-06-16',
      typeOptions: [
        { text: 'Day', value: 'day' },
        { text: '4 Day', value: '4day' },
        { text: 'Week', value: 'week' },
        { text: 'Month', value: 'month' },
        // { text: 'Custom Daily', value: 'custom-daily' },
        // { text: 'Custom Weekly', value: 'custom-weekly' }
      ],
      cards:[],


      selectedDate:'',
      teacher_bookings:[],
      student_bookings:[],
      tempItems:[],
      items:[],
      loading1:false,
      loading:false,
      noValues:'',
      teacherId:'',
      event:'',
      eventEditPopup:false,
      checkInValue:'',

      selectedEventId:'',
      eventMessageType:'',
      eventMessage:'',

      eventCancelAlert:'',
      eventCancelMsg:'',
      confirmDelete:false,
      confirmDeleteData:'',
      deleteEventLoading:false,
      alertType:'',
      msg:'',
      eventAlert:'',
      eventMsg:'',
      viewModulePopup:'',
      viewModulePopupData:'',
      selectedClassId:'',
      selectedClassPackageId:'',
      selectedClass:'',
      dob:'',
      msg:'',
      msgText:"",
      alertType:"",
      loading11:true,
      arrayEvents:[],
      dob:'',
      birthday:'',
      selectedTime:'',
      ChangeTime: false,
      dialog: false,
      timeslot:[]
    }),
    created:function(){
      this.teacherId=this.$route.params.id
    },
    methods:{
      cancelBooking(bookingId){
        // console.log(bookingId)
        this.alertType=""
        this.msg=""
        this.loading=true

        // http://127.0.0.1:8000/api/admin/student_class/admin_cancel
        api.postData('admin/student_class/teacher_cancel',{student_bookings_id:bookingId,cancel_for:'all'})
        .then(res=>{
          if(res.status==201){

            this.loading=false
            this.eventCancelAlert="success"
            this.eventCancelMsg="You have successfully cancelled the class"
            api.postData('student/view_classes')
            .then(response=>{
              // console.log(response)
              this.$store.dispatch('setClasses',response.data)
            })
            setTimeout(()=>{
              this.dialog=false
              this.eventCancelAlert=""
              this.eventCancelMsg=""
            },1500)
            }
        }).catch(err=>{
          this.loading=false
          this.alertType="warning"
          this.msg="You cant cancel this class"

        })
      },
      setdate (value){
        // console.log(value)
        // this.$refs.menu1.save(value)
        this.dob=value
        this.birthday=false
      },
      ChangeBookTime(student_bookings_id,module_id,package_id,attendance,student_id){
        this.loading1=true
        this.alertType=''
        this.msg=''
        let Data={
          'student_id':student_id,
          'module_id':module_id,
          'package_id':package_id,
          'teacher_bookings_id':this.selectedTime,
          'student_bookings_id':student_bookings_id,
          'attendance':attendance
        }
        // this.loading1=false

        console.log(Data)
        let self=this
        api.postData('admin/student_class/update',Data)
        // http://127.0.0.1:8000/api/admin/student_class/update - student_id required
        .then(res=>{
          // console.log(res)
          // // console.log(res.status)
          if(res.status==201){
            // console.log("hello")
              this.loading1=false
              this.alertType="success"
              this.msg="You have successfully updated"
              self.loadClasses(self.selectedDate)
                setTimeout(()=>{
                  this.alertType=""
                  this.msg=""

                  api.getData('teacher/students_classes')
                  .then(res=>{
                      // console.log(res)
                      this.$store.dispatch('setTeacherClasses', )
                  })

                  this.ChangeTime=false
                },1500);
          }
        }).catch(err=>{
            this.loading1=false
            this.alertType="warning"
            this.msg="Change time is failed"
        })
      },
      setClassDetails(moduleId,packageId,className,studentId){
          this.loading1=true
          this.selectedClassId=moduleId
          this.selectedClassPackageId=packageId
          this.selectedClass=className
          this.dob=''
          this.msg=false
          this.msgText=""
          this.alertType=""
          this.loading11=true
          this.arrayEvents=[]

          this.timeslot=[]
          let data={
            'student_id':studentId,
            'module_id':moduleId,
            'package_id':packageId
          }
          try{
            // api.postData("teacher/getTime",data)
            api.postData("admin/student_class/get_time",data)
            // http://127.0.0.1:8000/api/admin/student_class/get_time
            .then(res=>{
              // console.log(res)
              if(res.status==204){
                      this.loading1=false
                      this.msgText="No time for booking this module"
                      this.alertType="warning"
                      this.msg=true
              }else if(res.status==203){
                      this.loading1=false
                      this.msgText="Not buy this package."
                      this.alertType="warning"
                      this.msg=true
              }else if(res.status==200){
                  setTimeout(() => {
                      this.teacherTime=res.data
                      // console.log(res.data)

                      this.loading1=false
                      this.alertType=""
                      this.msgText=""
                      this.msg=false
                      this.arrayEvents=[]
                      let arrayEvents=[]
                      const response=res.data
                      for(var x=0;x<response.times.length;x++){
                        for(var y=0;y<response.times[x].length;y++){
                          var date=response.times[x][y].date
                            arrayEvents.push(date)
                        }
                      }
                      this.arrayEvents = arrayEvents
                      this.loading1=false
                  }, 500);
              }else{
                this.loading1=false
                this.alertType="warning"
                this.msg="No time for booking this module"
              }
              // console.log()
            }).catch(err=>{
                this.loading1=false
                this.alertType="warning"
                this.msg="No time for booking this module"
            })

          }catch(e){
            this.loading1=false
            this.alertType="warning"
            this.msg="Error"
          }

      },
       GetTime(selectedDate){
        console.log(selectedDate);
        this.loading1=true

        this.timeslot=''
        var time=[];
        try{
          for(var x=0;x<this.teacherTime.times.length;x++){
              for(var y=0;y<this.teacherTime.times[x].length;y++){
                if(this.teacherTime.times[x][y].date==selectedDate){
                  var Data={
                    "time_from":this.teacherTime.times[x][y].time_from,
                    "id":this.teacherTime.times[x][y].id
                  }
                time.push(Data)
                }
              }
          }
          this.timeslot=time
          this.loading1=false

        }catch(e){
          this.loading1=false

        }
      },
      setModulePopupData(item){
        this.calenderdialog=false
        this.viewModulePopupData=item
        this.viewModulePopup=true
      },
      deleteEvent(eventId){
          this.deleteEventLoading=true
          console.log("DeleteEvent")
          console.log(eventId)
          this.eventAlert=""
          this.eventMsg=""
          // this.loadClasses(this.selectedDate,true)
          api.getData('admin/adminDeleteEvent/'+eventId)
          .then(res=>{
            this.deleteEventLoading=false
            if(res.status==201){
              this.eventAlert="success"
              this.eventMsg="Event is successfully deleted"
            }
            this.confirmDelete=false
            this.loadClasses(this.selectedDate,false,'none')
          }).catch(err=>{
            this.deleteEventLoading=false
            this.eventAlert="warning"
            this.eventMsg="Event deletion is failed"
          })
      },
      UpdateEvent(){
        this.loading=true
        this.alertType=""
        this.msg=""
        let TeacherId=this.$route.params.id
        let data={
            title:this.event.selectedPlan,
            start_date:this.event.start_date,
            end_date:this.event.end_date,
            teacher_id:TeacherId,
            event_id:this.selectedEventId
        }
        console.log(data)
        if(this.event.start_date!=null && this.event.end_date!=null){
          if(this.event.selectedPlan!=null){
              api.postData('admin/adminUpdateEvent',data)
              .then(res=>{
                  if(res.status==201){
                    this.alertType="success"
                    this.msg="Your event successfully updated"
                    this.loading=false
                    // setTimeout(function(){
                    //   router.push({ name: 'Verification' });
                    // }, 3000);
                  }
              }).catch(err=>{
                    this.alertType="warning"
                    this.msg="Event updation failed"
                    this.loading=false
              })
          }else{
            this.alertType="warning"
            this.msg="Please enter your plan"
            this.loading=false
          }
        }else{
            this.alertType="warning"
            this.msg="Please Choose dates"
            this.loading=false
        }
      },
      confirmDeletePopup(item){
        this.calenderdialog=false
        this.confirmDeleteData=item
        this.confirmDelete=true
      },
      editEventPopup(eventId){
        this.sheet=false
        this.selectedEventId=eventId
          console.log("Hello",eventId)
          api.getData('admin/adminGetEvent/'+eventId)
          .then(res=>{
            if(res.status==200){
              this.event.start_date=res.data.start_date
              this.event.end_date=res.data.end_date
              this.event.selectedPlan=res.data.title
            }
          }).catch(err=>{
            // this.eventAlert="warning"
          //   this.eventMsg="Event deletion is failed"
          })
          this.eventEditPopup=true
      },
      changeStatus(stat,teacher_booking_id){
        console.log(status)
        let status=(stat==true)?'enable':'disable'
        let TeacherId=this.$route.params.id
        let Data={
          teacher_bookings_id:teacher_booking_id,
          status:status,
          teacher_id:TeacherId
        }
        api.postData('admin/disableEnableASlot',Data)
        .then(res=>{

        }).catch(err=>{

        })
      },
      loadData(event){
        console.log(event)
        this.selectedDate=event.date
        this.calenderdialog=true
        this.loadClasses(event.date,true)
      },
      // loadClasses(){
      loadClasses(selectedDate,Loading=true,type='all'){
          this.alertType=''
          this.msg=''
          this.calenderdialog=true
          if(Loading){
            this.loading =true
            this.loading1 =true
            this.eventAlert=''
            this.items=[]
          }
          console.log(selectedDate)
          this.noValues=""
          // selectedDate=this.selectedDate
          this.tempItems=[]
          let events=[]
          let TeacherId=this.$route.params.id
          api.postData('admin/adminGetEventByDate',{date:selectedDate,teacher_id:TeacherId})
          .then(res=>{
              events=res.data
          }).catch(err=>{
          })
          let self=this
          // debugger
          api.postData('admin/viewTeacherFreeSlotsAndBooking',{date:selectedDate,teacher_id:TeacherId})
          .then(res=>{
              // debugger
              // console.log(res)
              if(res.data.teacher_events){
                self.events=res.data.teacher_events
              }
              if(res.data.student_bookings){
                self.student_bookings=res.data.student_bookings
              }
              if(res.data.student_bookings){
                self.student_bookings=res.data.student_bookings
              }
              if(res.data.teacher_bookings){
                self.teacher_bookings=res.data.teacher_bookings
              }
              if(self.student_bookings.length==0 && self.teacher_bookings.length==0){
                  setTimeout(()=>{

                    if(events.length>0){
                      self.loading1=false
                      this.loading=false
                      events.forEach(element=>{
                      let temp={
                        id:element.id,
                        bookType:"teacher_events",
                        avatar: 'https://s3.amazonaws.com/peoplepng/wp-content/uploads/2018/07/06051116/Event-PNG-Image.png',
                        title: element.title,
                        subtitle: element.start_date +"-"+element.end_date,
                        // name:element.module.name,
                        // date:element.date,
                        // image:element.module.image_path,
                        // time:element.time,
                        // id:element.id
                      }

                      self.tempItems.push(temp)
                      // let line={divider: true, inset: true}
                      // self.tempItems.push(line)
                      self.items=self.tempItems
                    })
                    }else{
                      this.loading =false
                      this.alertType="error"
                      this.msg="There are no event and bookings"
                    }
                  },1000);

              }else{
                  self.loading1=false
                  self.loading=false
                  self.student_bookings.forEach((element,index)=>{
                      let temp={
                        bookType:"student_booking",
                        avatar: element.users.image_path,
                        title: element.users.name,
                        subtitle: element.time,
                        name:element.module.name,
                        date:element.date,
                        image:element.module.image_path,
                        time:element.time,
                        id:element.id,
                        module_id:element.module_id,
                        package_id:element.package_id,
                        student_id:element.student_id,
                        attendance:element.attendance
                      }

                      self.tempItems.push(temp)
                      // let line={divider: true, inset: true}
                      // self.tempItems.push(line)
                  })
                  let teacherBookings=self.teacher_bookings
                  teacherBookings.forEach((element,index)=>{
                      let desc
                      if(element.description){
                        desc="&mdash;"+element.description
                      }else{
                        desc=""
                      }
                      let status=element.status=='P'?true:false
                      let temp={
                        id:element.id,
                        bookType:"teacher_bookings",
                        avatar: 'https://png.pngtree.com/svg/20170316/670f13ac9c.svg',
                        title: 'Free Slot',
                        subtitle: element.time_from +"-"+element.time_to,
                        status:status
                        // name:element.module.name,
                        // date:element.date,
                        // image:element.module.image_path,
                        // time:element.time,
                        // id:element.id
                      }

                      self.tempItems.push(temp)
                      // let line={divider: true, inset: true}
                      // self.tempItems.push(line)
                  })
                  //Adding Events to List
                  events.forEach(element=>{
                    let title
                      if(element.title){
                        title="&mdash; "+element.title
                      }else{
                        title=""
                      }
                    let temp={
                      id:element.id,
                      bookType:"teacher_events",
                      avatar: 'https://s3.amazonaws.com/peoplepng/wp-content/uploads/2018/07/06051116/Event-PNG-Image.png',
                      title: element.title,
                      subtitle: element.start_date +"-"+element.end_date,

                    }

                    self.tempItems.push(temp)
                    // let line={divider: true, inset: true}
                  })
                  self.items=self.tempItems
                  // console.log(self.items)

                  // teacher_events
                  // console.log(this.items)


              }
          }).catch(err=>{
              this.loading =false
              this.alertType="error"
              this.msg="There are no slots"
                  //   events.forEach(element=>{
                  //   let title
                  //     if(element.title){
                  //       title="&mdash; "+element.title
                  //     }else{
                  //       title=""
                  //     }
                  //   let temp={
                  //     id:element.id,
                  //     bookType:"teacher_events",
                  //     avatar: 'https://s3.amazonaws.com/peoplepng/wp-content/uploads/2018/07/06051116/Event-PNG-Image.png',
                  //     title: element.title+'<span class="grey--text text--lighten-1"></span>',
                  //     subtitle: "<span class='text--primary'>"+element.start_date +"-"+element.end_date +"</span> "+title,
                  //     // name:element.module.name,
                  //     // date:element.date,
                  //     // image:element.module.image_path,
                  //     // time:element.time,
                  //     // id:element.id
                  //   }

                  //   self.tempItems.push(temp)
                  //   let line={divider: true, inset: true}
                  //   self.tempItems.push(line)
                  // })
                  // self.items=self.tempItems
          })
          // if(type=='all'){
          //   this.sheet=true
          // }
      }
    },
    components:{
      CreateClass,
      DateDropdown,
      CreateEvent,
      FreeSlots,
      PulseLoader
    }
  }
</script>
<style>
  .filter-class .v-text-field.v-text-field--enclosed .v-text-field__details{
    display: none;
  }
  .filter-class .v-input__slot{
    min-height: 27px!important;
    margin-bottom: 0px !important;
     margin-top: 6px;
  }
</style>



// WEBPACK FOOTER //
// src/components/test/NewCalender.vue